// extracted by mini-css-extract-plugin
export var gif = "_kl-0";